import React from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import Input from '../../Input';

// TODO: Remove this when https://github.com/text-mask/text-mask/issues/748 is fixed
class MaskedInputWithShowMaskOnFocus extends MaskedInput {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  onFocus() {
    if (this.inputElement && this.inputElement.value) {
      return;
    }

    setTimeout(() => {
      if (this.inputElement.value) {
        return;
      }
      this.inputElement.value = ' ';
      this.textMaskInputElement.update();
    }, 0);
  }

  onBlur(event) {
    if (this.props.onBlur) {
      this.props.onBlur(event);
    }

    if (this.props.value) {
      return;
    }

    setTimeout(() => {
      if (this.inputElement && this.inputElement.value) {
        this.inputElement.value = '';
      }
      this.textMaskInputElement.update();
    }, 0);
  }

  render() {
    const { render, ...props } = this.props;

    delete props.mask;
    delete props.guide;
    delete props.pipe;
    delete props.placeholderChar;
    delete props.keepCharPositions;
    delete props.value;
    delete props.onBlur;
    delete props.onChange;
    delete props.showMask;

    return render(this.setRef, {
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onChange: this.onChange,
      defaultValue: this.props.value,
      ...props,
    });
  }
}

MaskedInputWithShowMaskOnFocus.defaultProps = {
  showMaskOnFocus: true,
  render: (ref, props) => <input ref={ref} {...props} />,
};

MaskedInputWithShowMaskOnFocus.propTypes = {
  showMaskOnFocus: PropTypes.bool,
};

export default MaskedInputWithShowMaskOnFocus;
